import { enableSpinner } from '@js/utilities/spinner';

import { initProductsListPromotion } from '@js/pages/category/productsListPromotion';

const initProductsPresentationBridge = () => {
    document.addEventListener('click', (e) => {
        const button = e.target.closest('.js-open-products-presentation');
        if (!button) return;

        const products = JSON.parse(button.dataset.products || '[]');
        window.dispatchEvent(
            new CustomEvent('open-products-presentation', { detail: { products } })
        );
    });
};

const ProductsList = () => {
    const productsListContentContainer = document.querySelector(
        '.js-products-list-content-container'
    );

    // ProductsListPaginatorController();
    initProductsListPromotion();
    initProductsPresentationBridge();
    // fetchBadges(collectIds(productsListContentContainer));

    window.addEventListener('filters.filtering', () => {
        document.querySelectorAll('.js-filtering-show-spinner').forEach(enableSpinner);
    });

    window.addEventListener('filters.filtered', async (e) => {
        // console.log('filters.filtered', e.detail);

        const html = await e.detail.productsListResponse.text();
        productsListContentContainer.innerHTML = html;

        window.dispatchEvent(new Event('RemoteContentLoaded'));
        window.dispatchEvent(new Event('products-list-apps-mount'));
        const productsList = document.querySelector('.js-products-list');

        // ProductsListPaginatorController();
        window.dispatchEvent(
            new CustomEvent('products-list-loaded', {
                detail: {
                    products_count: productsList.dataset.productsCount,
                    products_per_page: productsList.dataset.productsPerPage,
                    products_total_pages: productsList.dataset.productsTotalPages,
                    products_current_page: productsList.dataset.productsCurrentPage,
                },
            })
        );

        const filtersScrollTarget = document.querySelector('#filters-scroll-target');

        if (filtersScrollTarget) {
            const yOffset = -160; // adjust this offset (in px) as needed
            const y =
                filtersScrollTarget.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    });
};

export default ProductsList;
